import React, { useEffect } from 'react';
import FormFileInput, { FormFileInputProps } from 'legacy-components/form/input/FormFileInput';
import { useFormState } from 'react-final-form';

interface CustomFileInputProps extends FormFileInputProps {
  onFileChange?: (files: File[] | undefined) => void;
}

const CustomFileInput: React.FC<CustomFileInputProps> = ({ onFileChange, ...props }) => {
  const formState = useFormState({ subscription: { values: true } });
  
  useEffect(() => {
    const files = formState.values?.[props.input.name];
    
    if (onFileChange) {
      onFileChange(files);
    }
  }, [formState.values, props.input.name, onFileChange]);

  return <FormFileInput {...props} />;
};

export default CustomFileInput;
